import React, { useState,useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { Spin, Row, Col, Button, Input, Modal, Radio, Tabs } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import util from '../../util/util'
import FullfillmentTable from './fullfillment.table'
import '../../css/users.scss'
import { useLocation } from 'react-router'
import { fetchUsers } from '../../store/action/user.action'
import { messageGroupBy } from '../../store/action/actioncases.action'
import {
  getFullfillments,
  getFullfillmentsCount,
} from '../../store/action/device.action'
import { Fullfillment as DeviceFullfillment } from '../../component'
var { Search } = Input
const { TabPane } = Tabs
const { Filter, Filterlist } = DeviceFullfillment
const Fullfillment = (props) => {
  let fetchinput = {
    metadata: { current: 1, pageSize: 20 },
    filters: { status: 'Pending' },
    sorter: { field: 'orderDate', order: 'descend' },
  }
  const location = useLocation()

  useEffect(() => {
    props.messageGroupBy(null)
    props.getFullfillments({ ...fetchinput, filters: {...props.filters, status: 'Pending' } })
    props.getFullfillmentsCount(props.filters?.type)
  }, [])
  
  const getPending = () => {
    // console.log("Getting counts", props.fullfillmentcount)
    props.getFullfillments({
      sorter: props.sorter,
      metadata: props.metadata,
      filters: { ...props.filters, status: 'Pending' },
    })
    props.getFullfillmentsCount(props.filters?.type)
  }
  const getShipped = () => {
    props.getFullfillments({
      sorter: props.sorter,
      metadata: props.metadata,
      filters: { ...props.filters, status: 'Shipped' },
    })
    props.getFullfillmentsCount(props.filters?.type)
  }
  const handleTabChange = (key) => {
    if (key === '1') {
      getPending()
    } else if (key === '2') {
      getShipped()
    }
  }
  return props.token == undefined ? (
    <Redirect to='/login' />
  ) : (
    <>
      <Spin spinning={props.isLoading}>
        <Col className='userContainer'>
          <Filter />
          <Row className={'actionRow'} justify={'end'}>
            <Col flex={'60%'} style={{ marginRight: 'auto' }}>
              <Row className={'headerText'} gutter={20} align={'middle'}>
                <Col flex={'40px'}> Fullfillment </Col>
              </Row>
            </Col>
            <Col>
                <div style={{ width: '250px', overflow: 'hidden' }}>
           <Tabs
                defaultActiveKey='1'
                tabBarStyle={{ marginLeft: '40px' }}
                onChange={handleTabChange}
              >
                <TabPane
                  tab={
                    'Pending (' +
                    (props.fullfillmentcount
                      ? props.fullfillmentcount.pending
                      : 0) +
                    ')'
                  }
                  key='1'
                />
                <TabPane
                  tab={
                    'Shipped (' +
                    (props.fullfillmentcount
                      ? props.fullfillmentcount.shipped
                      : 0) +
                    ')'
                  }
                  key='2'
                />
              </Tabs>
                </div>
            </Col>
          </Row>
          <FullfillmentTable />
        </Col>
      </Spin>
    </>
  )
}

Fullfillment.propTypes = {
  isLoading: PropTypes.bool,
  token: PropTypes.string.isRequired,
  deleteSurgeons: PropTypes.func.isRequired,
  pagination: PropTypes.object,
  sorter: PropTypes.object,
  searchText: PropTypes.string,
  active: PropTypes.bool,
  path: PropTypes.string,
  fullfillmentcount: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    isLoading: state.device.isLoading,
    customer: state.profile.customer,
    successMessage: state.profile.successMessage,
    pagination: state.user.pagination,
    searchText: state.user.searchText,
    active: state.user.active,
    company: state.profile.company,
    user: state.profile.user,
    fullfillmentcount: state.device.fullfillmentcount,
    fullfillments:state.device.fullfillments,
    filters: state.device.fullfillmentFilter,
    sorter: state.device.fullfillmentSorter,
    metadata: state.device.fullfillments?.metadata,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    messageGroupBy: (data) => dispatch(messageGroupBy(data)),
    getFullfillments: (params) => dispatch(getFullfillments(params)),
    getFullfillmentsCount: (type) => dispatch(getFullfillmentsCount(type)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Fullfillment)
